var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 50,
    viewBox: "0 0 71 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_5131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0246 32.1426C50.1212 32.1426 46.1496 36.1381 46.1496 41.0711C46.1496 46.0042 50.1212 49.9997 55.0246 49.9997C59.928 49.9997 63.8996 46.0042 63.8996 41.0711C63.8996 36.1381 59.928 32.1426 55.0246 32.1426ZM15.9746 32.1426C11.0712 32.1426 7.09961 36.1381 7.09961 41.0711C7.09961 46.0042 11.0712 49.9997 15.9746 49.9997C20.878 49.9997 24.8496 46.0042 24.8496 41.0711C24.8496 36.1381 20.878 32.1426 15.9746 32.1426ZM12.9682 17.8569H24.8496V7.14258H17.2393L12.9682 17.8569ZM40.0813 7.14258H30.1746V17.8569H48.5902L40.0813 7.14258Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6875 17.8571L45.6286 2.68973C44.2752 0.993304 42.2339 0 40.0817 0H17.2397C14.322 0 11.715 1.77455 10.6389 4.49777L5.325 18.1138C2.27422 18.9062 0 21.6853 0 25.0112V37.5112C0 39.4866 1.58641 41.0826 3.55 41.0826C3.55 34.1853 9.11906 28.5826 15.975 28.5826C22.8309 28.5826 28.4 34.1853 28.4 41.0826H42.6C42.6 34.1853 48.1691 28.5826 55.025 28.5826C61.8809 28.5826 67.45 34.1853 67.45 41.0826C69.4136 41.0826 71 39.4866 71 37.5112V31.2612C71 23.8504 65.0427 17.8571 57.6875 17.8571ZM24.85 17.8571H12.9686L17.2397 7.14286H24.85V17.8571ZM30.175 17.8571V7.14286H40.0817L48.6017 17.8571H30.175Z",
    fill: "#828284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_5131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.4695dd228201b817d410469e166ae611.svg";
export { ForwardRef as ReactComponent };